import React from 'react';
import { bool, func, string, element } from 'prop-types';
import styled, { css } from 'styled-components';

import Wrapper from '../Wrapper';
import { SubBodyText } from '../Text/Heading';

const RadioWrapper = styled(Wrapper)`
  display: flex;
  align-items: ${({ isHasSubText }) =>
    isHasSubText ? 'flex-start' : 'center'};
  flex-direction: row;
  cursor: pointer;
  width: fit-content;
`;

const focusStyed = css`
  &:focus {
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08);
  }
`;

const Radio = styled.span`
  width: 20px;
  height: 20px;
  min-width: 20px;
  border-radius: 40px;
  border: 1px solid
    ${({ move, theme }) =>
      move ? theme.colors.secondaryMove : theme.colors.greyLight};
  background: ${({ checked, move, theme }) =>
    checked
      ? move
        ? theme.colors.secondaryMove
        : theme.colors.secondary
      : theme.colors.primaryWhite};
  ${focusStyed};
`;

const CheckedMark = styled.span`
  width: 8px;
  height: 8px;
  background: ${({ theme }) =>
    theme.colors.primaryWhite
      ? theme.colors.primaryWhite
      : theme.colors.default};
  margin: 6px;
  border-radius: 40px;
  display: block;
  ${focusStyed};
`;

const RadioButton = ({
  isSelected,
  id,
  text,
  onChange,
  isVertical,
  textColor,
  subText,
  isTextBold,
  isMoveEnabled,
}) => {
  const handelKeyDown = id => event => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onChange(id);
    }
  };
  return (
    <RadioWrapper
      className="radio-button"
      onMouseDown={() => onChange(id)}
      onKeyDown={handelKeyDown(id)}
      isHasSubText={!!subText}
    >
      <Radio tabIndex={0} checked={isSelected} move={isMoveEnabled}>
        {isSelected && <CheckedMark />}
      </Radio>
      <Wrapper marginLeft={isVertical ? '18px' : '8px'}>
        <SubBodyText
          lineHeight="18px"
          color={textColor}
          fontWeight={isTextBold ? 500 : 400}
        >
          {text}
        </SubBodyText>
        {subText}
      </Wrapper>
    </RadioWrapper>
  );
};

RadioButton.propTypes = {
  isSelected: bool,
  onChange: func,
  id: string,
  text: string,
  isVertical: bool,
  textColor: string,
  subText: element,
  isTextBold: bool,
  isMoveEnabled: bool,
};

RadioButton.defaultProps = {
  isSelected: false,
  onChange: () => {},
  id: '',
  text: '',
  isVertical: false,
  isTextBold: false,
  isMoveEnabled: false,
};

export default RadioButton;
